import { Big } from 'big.js';
import { bigToString, QuoteService } from 'quote-domain-core';
import { QuoteServiceCorridorAggregationService } from './quote-service-corridor-aggregation-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceAppliedPriceUpdateService {
    constructor(private readonly corridorAggregationService: QuoteServiceCorridorAggregationService) {
    }

    public updateServiceAppliedPrice(quoteService: QuoteService, newAppliedPrice: string): void {
        const result = this.corridorAggregationService.sumDevicesAndConsumablesAppliedPrices(quoteService);
        const appliedPriceOnlyNegociable = new Big(newAppliedPrice).minus(
            result.appliedPriceOnlyNonNegociableConsumables.plus(result.appliedPriceOnlyNonNegociableDevices)
        );
        const appliedPriceOnlyNonNegociable = result.appliedPriceOnlyNonNegociableConsumables.plus(result.appliedPriceOnlyNonNegociableDevices);

        this.corridorAggregationService.getJoinCorridorNegotiable(quoteService);
        Object.assign(quoteService, {
            appliedPrice: newAppliedPrice,
            appliedPriceOnlyNegociable: bigToString(appliedPriceOnlyNegociable),
            appliedPriceOnlyNonNegociable: bigToString(appliedPriceOnlyNonNegociable)
        });
        this.corridorAggregationService.updateServiceDistanceFromAppliedPrice(quoteService);
    }
}
